import { heroValuePartner } from '../../../../constants/partnerPageConst';
import { handleTrack } from '../../../../utils/tracker';
import { Button, ButtonVariants } from '../../../Atoms/Button';
import { navigationCtx } from '../context';
import { ISection } from '../nav-section/index';
import { INavigatorVariant } from '../types';
import { scrollIntoView } from '../utils';

export const HorizontalTabs: React.FC<INavigatorVariant> = ({
  className = '',
  scrollOffset = 0,
}) => {
  const { sections, activeSection, setActiveSectionCB, setJustScrolledCB } =
    navigationCtx();
  const handleClick = (
    e: React.MouseEvent | React.TouchEvent,
    id: string,
    element: HTMLDivElement
  ) => {
    e.preventDefault();
    setJustScrolledCB(true);
    setActiveSectionCB(id);
    scrollIntoView(element, scrollOffset);
    handleTrack({ label: 'sec-navbar-link', obj: e.target });
  };
  return (
    <nav className={`w-full flex items-center bg-white ${className}`}>
      <div className="wg-container w-full flex items-center justify-end">
        <ul className="flex items-center justify-center">
          {sections.map((section) => {
            const sectionProps: ISection = section.props;
            const { id, name } = sectionProps;
            return (
              <li
                onClick={(e) => {
                  handleClick(e, id, section.ref.current as HTMLDivElement);
                }}
                key={id}
                className={`text-s-14 cursor-pointer p-4 border-b-md ${
                  id === activeSection
                    ? 'text-blue-350 font-bold border-blue-350'
                    : 'text-font-400 font-medium border-b-white'
                }`}
              >
                {name}
              </li>
            );
          })}
        </ul>
        <a
          href={heroValuePartner.btnLink}
          rel="noreferrer"
          className="text-white ml-10"
          onClick={(e) =>
            handleTrack({ label: 'sec-navbar-button', obj: e.target })
          }
        >
          <Button
            variant={ButtonVariants.bluefilled}
            className="text-base px-5 my-2"
          >
            File Now
          </Button>
        </a>
      </div>
    </nav>
  );
};
